import { DesignTokens } from '@klarna/bubble-ui'

export const paymentMethodContainerCss = (
  designContext: DesignTokens.DesignContext,
  frameBackground: string,
  willShowTokenizationSnippet = false
) => ({

  padding: 16,
  borderColor: designContext.get<DesignTokens.Color>(frameBackground).toString(),
  borderRadius: 16,
  borderBottomLeftRadius: willShowTokenizationSnippet ? 0 : 16,
  borderBottomRightRadius: willShowTokenizationSnippet ? 0 : 16,
  borderTopWidth: 1,
  borderLeftWidth: 1,
  borderRightWidth: 1,
  borderBottomWidth: willShowTokenizationSnippet ? 0 : 1
}
)

export const tokenizationSnippetCss = (
  designContext: DesignTokens.DesignContext,
  frameBackground: string
) => ({
  padding: 16,
  borderColor: designContext.get<DesignTokens.Color>(frameBackground).toString(),
  borderTopLeftRadius: 0,
  borderTopRightRadius: 0,
  borderBottomLeftRadius: 16,
  borderBottomRightRadius: 16,
  borderLeftWidth: 1,
  borderRightWidth: 1,
  borderBottomWidth: 1
})
